/**
 * Valid benefit field names for Critical Illness LOC
 *
 * Used to filter out fields that don't belong to Critical Illness benefits when saving to API.
 * These fields represent the API structure (nested objects created by transforms).
 */

export const CRITICAL_ILLNESS_VALID_FIELDS = new Set([
  "objectType",

  // Nested benefit objects (created by transform, not flat grid fields)
  "employee",
  "spouse",
  "child",
  "invasiveCancer",
  "nonInvasiveCancer",
  "category1HeartAttack",
  "category1Stroke",
  "kidneyFailure",
  "maximumPayout",
  "occurrenceOfDifferentIllness",
  "additionalOccurrenceOfSameIllness",

  // Simple fields (not nested)
  "ageReductionSchedule",
  "preExistingCondition",
  "portability",
  "wellnessBenefit",
  "annualOpenEnrollment",
  "ageBasis",

  // Flat fields
  "benefitClassAvailability",

  // Extended (non-v5) fields
  "extended",
]);
